import React from "react";
import { colors } from "../common/mixins";

interface ProductProps {
  color?: string;
}

export const ProductIcon = ({ color = colors.primary }: ProductProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4225_34129)">
      <g clipPath="url(#clip1_4225_34129)">
        <path
          d="M5.25 7.125H17.75"
          stroke={color}
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.75 18.375H5.25V7.125L7.75 4.625H15.25L17.75 7.125V18.375Z"
          stroke={color}
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.625 10.25C14.625 12 13.25 13.375 11.5 13.375C9.75 13.375 8.375 12 8.375 10.25"
          stroke={color}
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4225_34129">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_4225_34129">
        <rect width="15" height="15" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);
